import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";
export const ReligiaoList = props => <DefaultDataTable data={props} />;
